import React, { useEffect } from 'react';
import _isEmpty from 'lodash/isEmpty';
import _get from 'lodash/get';
import './GlobalFooter.scss';
import Link from '../../Atoms/Link/Link';
import Heading from '../../Atoms/Heading/Heading';
import {
  FooterComponentsProps,
  NavigationSection,
  NavigationSectionItem,
} from '../../Interfaces/FooterInterface';
import { setMaxTitleHeight } from '../../Templates/Footer/Util';

const GlobalFooter: React.FC<FooterComponentsProps> = ({ apiData, analyticsHandler, testAutoId }) => {
  const navigationSections = _get(apiData, ['navigationSections'], []);

  const navigationColumns =
    !_isEmpty(navigationSections) &&
    navigationSections.map((column: NavigationSection) => {
      const titles = _get(column, ['sectionName'], '');
      const items = _get(column, ['navigationSectionItems'], []);
      const links =
        !_isEmpty(items) &&
        items.map((link: NavigationSectionItem) => {
          const title = _get(link, ['alternateText'], '');
          const analyticsText = _get(link, ['analyticsText'], '').replace(/\s+/g, '-').toLowerCase();
          return (
            <li key={title} className="global-footer__item">
              <Link
              data-testid={title}
                text={title}
                onClick={() => analyticsHandler(analyticsText)}
                href={_get(link, ['href'])}
                className="global-footer__link"
                data-testauto-id = {analyticsText}
              />
            </li>
          );
        });

      return (
        <div key={_get(column, ['sectionName'])} className="global-footer__col">
          <Heading title={titles}  level="span" className="global-footer__title" />
          <ul className="global-footer__list">{links}</ul>
        </div>
      );
    });

  useEffect(() => {
    const maxHeight = setMaxTitleHeight();
    const titleElements = document.querySelectorAll('.global-footer__title');

    titleElements.forEach(titleElement => {
      (titleElement as HTMLElement).style.height = maxHeight + 'px';
    });
  });

  return (
    <div className="global-footer__container" data-testid={testAutoId}>
      <div className="global-footer__cols">
        {navigationColumns}
        <div className="global-footer__col" id="footer__last-column"></div>
      </div>
    </div>
  );
};

export default GlobalFooter;
